/* eslint-disable sort-keys */

const defaultState = {
  flexes: {
    active: [],
    duration: 9000, // ms
  },
  game: {
    title: "Twitch Trivia Night",
    tagline: "Test Your Knowledge",
    gameMode: "test",
    question: {
      question: "What colour is the sky?",
      answers: [],
    },
    answersSelectedBy: {
      answers: [
        { correct: false, selectedByPlayers: 20, answer: "Orange" },
        { correct: true, selectedByPlayers: 33, answer: "Blue" },
        { correct: false, selectedByPlayers: 15, answer: "Green" },
        { correct: false, selectedByPlayers: 32, answer: "Purple" }
      ],
    },
    countdown: {
      startTime: 20,
      timeRemaining: 20000,
      isStarted: false,
    },
    isRevealed: false,
    totalScores: [],
    totalPlayers: 0,
    skin: {
      bannerImage: "",
      colors: {
        primary: "#0F1635",
        secondary: "#FFFFFF",
        primaryFont: "#FFFFFF",
        secondaryFont: "#0F1635",
        variables: "#1FA7DF",
        background: "#4F4F4F",
        highlight: "#EC8B1C",
        correctBackground: "#6CD379",
        correctForeground: "#2DB5AB",
        wrongBackground: "#EA116F",
        wrongForeground: "#BC0F62",
        incorrect: "#CECECE",
        roundLeaderboard: "#cb357e",
        totalLeaderboard: "#1fa2d8",
        finalLeaderboard: "#583ca2"
      },
      name: "",
      phoneImage: "",
      primaryFont: "Dosis",
      secondaryFont: "Dosis"
    }
  },
  isRequesting: false,
  error: ""
}

export default defaultState